<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("訂單") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-table>
            <md-table-row>
              <md-table-head>{{ $t("日期") }}</md-table-head>
              <md-table-head>{{ $t("訂單編號") }}</md-table-head>
              <md-table-head>{{ $t("价钱") }}</md-table-head>
              <md-table-head>{{ $t("狀態") }}</md-table-head>
            </md-table-row>

            <md-table-row v-for="(order, order_key) in orders" :key="order_key">
              <md-table-cell>{{order.created_at}}</md-table-cell>

              <md-table-cell>
                <router-link :to="{ name: 'order', params: {id: order.id}}">
                  {{order.id}}
                </router-link>
              </md-table-cell>

              <md-table-cell>${{order.payment_amount}}</md-table-cell>

              <md-table-cell>{{ $t("已付款") }}</md-table-cell>
              
            </md-table-row>

          </md-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "orders",
  bodyClass: "orders-page",
  props: {},
  data() {
    return {
      orders: []
    };
  },
  methods: {
    async getOrders() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_order_get.php",
        data: {
          member_id: this.$store.state.member_id
        }
      });

      this.orders = response.data.orders;

      this.loader.hide();
    },
  },
  computed: {
    display_order() {
      return this.order.map(p => {
        p.sub_total = parseFloat(p.price) * parseFloat(p.quantity);
        p.price = this.$numeral(p.price).format("0,0");
        p.sub_total = this.$numeral(p.sub_total).format("0,0");
        return p;
      });
    }
  },
  mounted() {
    this.getOrders();
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.img-product {
  height: 150px;
}
</style>